function times<T>(callback: (index: number) => T, count: number): T[] {
  return new Array(count).fill(0).map((_, index) => callback(index));
}

export default times;
